import { mapToCompanyInfoList } from 'helpers/mapToCompanyInfoList';
import { ICompanyList } from '../../../models';
import { IClientListInfoItem, IClientList } from '../models';

export function mapCompanyList(
	titles: IClientListInfoItem[],
	list?: IClientList,
): ICompanyList {
	return (
		list?.map(
			({
				id,
				formalName,
				logoUrl,
				surveyCountLimit,
				surveyCount,
				locationCount,
				domainCount,
				employeesCount,
				officeCount,
				deleted,
			}) => ({
				id,
				logoUrl,
				formalName,
				allowedLimit: surveyCountLimit,
				sent: surveyCount,
				infoList: mapToCompanyInfoList(
					{
						locationCount,
						domainCount,
						employeesCount,
						officeCount,
					},
					titles,
				),
				deleted,
			}),
		) || []
	);
}
